<template>
  <div>
    <v-container class="mt-5">
      <job-backlog-table :teams="teams" :subdivisions="mappedSubdivisions" />
    </v-container>
    <v-container class="mt-5">
      <v-row>
        <v-col>
          <v-btn
            :loading="isLoading && clicked === 'data'"
            color="success"
            class="mx-2"
            @click="getData()"
          >
            Refresh data
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
            :loading="isLoading && clicked === 'notifications'"
            color="secondary"
            class="mx-2"
            @click="sendNotifications()"
          >
            Send Team Notifications
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _cloneDeep from "lodash.clonedeep";
import JobBacklogTable from "../components/jobs/JobBacklogTable.vue";

export default {
  components: {
    JobBacklogTable,
  },
  data() {
    return {
      clicked: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.clicked = "data";
      this.$store.dispatch("getSubdivisions");
      this.$store.dispatch("getTeams");
      this.$store.dispatch("getUsers");
      this.$store.dispatch("getAdminCms");
      this.$store.dispatch("getPermissions");
    },
    sendNotifications() {
      this.clicked = "notifications";
      this.$store.dispatch("sendNotifications");
    },
  },
  computed: {
    ...mapGetters(["subdivisions", "teams", "isLoading", "users", "adminCms"]),
    mappedSubdivisions() {
      return _cloneDeep(this.subdivisions);
    },
  },
};
</script>
